import { CharacterResult } from "common/character/dto/CharacterResult";
import styled from "styled-components";
import CharacterSingleNav from "components/common/character/CharacterSingleNav";
import { Divider } from "@mui/material";
import { characterLinkSingle } from "common/character/character_link_common";
import NavLinkUndecorated from "components/common/style/link/NavLinkUndecorated";
import CharacterDescription from "components/common/character/CharacterDescription";
import { DivMarginTop } from "components/common/style/margin/DivMarginTop";
import CharacterRelateContainEditNav from "components/common/character/CharacterRelateContain/CharacterRelateContainEditNav";
import CharacterRelateContainNav from "components/common/character/CharacterRelateContain/CharacterRelateContainNav";
import { useCharacterItemMode } from "./useCharacterItemMode";
import RelatePlayAnswer from "components/pages/answer/RelatePlay/RelatePlayAnswer";
import React from "react";

type CharacterItemProps = {
  character: CharacterResult;
  isRelatePlay?: boolean;
};

const CharacterItem = ({ character, isRelatePlay }: CharacterItemProps) => {
  const { relateEdit, relateNav, editNav } = useCharacterItemMode(isRelatePlay);

  React.useEffect(() => {
    console.log("relateNav", relateNav);
  }, [relateNav]);

  return (
    <CharacterDiv>
      <Divider />
      <Div>
        <DivMarginTop mt={2}>
          <NavLinkUndecorated
            to={characterLinkSingle(character.id)}
            target="_blank"
          >
            <LetterDiv>{character.letter}</LetterDiv>
          </NavLinkUndecorated>
        </DivMarginTop>
        <DivMarginTop mt={1}>
          <CharacterDescription character={character} />
        </DivMarginTop>
        {relateNav === "navigation" && (
          <DivMarginTop mt={1}>
            <CharacterRelateContainNav character={character} />
          </DivMarginTop>
        )}
        {relateEdit === "edit" && (
          <CharacterSingleNavDiv>
            <CharacterRelateContainEditNav
              characterId={character.id}
              contain={character.relate.contain ?? []}
            />
          </CharacterSingleNavDiv>
        )}
        {editNav === "edit" && (
          <CharacterSingleNavDiv>
            <CharacterSingleNav character={character} />
          </CharacterSingleNavDiv>
        )}
      </Div>
      <Div>{isRelatePlay && <RelatePlayAnswer />}</Div>
    </CharacterDiv>
  );
};

const CharacterDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  line-height: 1.25rem;
`;

const Div = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  line-height: 1.25rem;
`;

const LetterDiv = styled.div`
  font-size: 4rem;
  line-height: 4rem;
`;

const CharacterSingleNavDiv = styled.div`
  margin-top: 1rem;
`;

export default CharacterItem;
